import React, { useState } from "react";
import { useFormik } from 'formik';
import * as Yup from "yup";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import totalRide from "../../../assets/imgs/total ride.png"
import paymentPending from "../../../assets/imgs/pending.png"
import paymentFullfilled from "../../../assets/imgs/credit-card-payment.png"
import { Timeline } from "primereact/timeline";
import { Rating } from "primereact/rating";
import "../payments/payment.css"

const AllRides = ({ dataData }) => {
    // console.log(dataData, "dataData")
    // console.log(dataData.map((item) => {
    //     return item.fare
    // }), "dataDdsdsata")
    const [saveBtnLoading, setSaveBtnLoading] = useState(false);
    const userId = useSelector((state) => state.authenticationSlice?.userId)
    const history = useHistory();
    const dispatch = useDispatch();
    const [value, setValue] = useState(null);


    const validationSchema = Yup.object().shape({
        vehicleType: Yup.mixed().required("This field is required."),

    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            vehicleType: "",
            maker: "",
        },

        onSubmit: async (data) => {
            let payload = {
                userId: userId,
                dob: data?.dateOfBirth ? moment(data?.dateOfBirth).format("MM-DD-YYYY") : null,
            }
            setSaveBtnLoading(true);

            try {

            }
            catch (error) {
                // console.log(error)
            }
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };
    return (
        <>
            {/* col-12 */}
            {/* col-4 col-4 col-4 */}
            <div className="custom-payment-grid">
                {dataData.map((data) => (
                    <div key={[]} className="surface-card p-4">
                        <div className="grid">
                            <div className="col-12 xl:col-4 md:col-6 lg:col-6 sm:col-12 w-full px-1 border-round">


                                <div className="flex flex-row justify-content-between items-center">

                                    <h5 className="text-white" >Eman</h5>
                                </div>

                                <div className="flex flex-row justify-content-between mt-3">

                                    {/* <Timeline
value={events}
align="left"
className="custom-timeline"
marker={item => (
    <span className={`p-timeline-event-icon p-pt-2 text-white`}>
        <i className={item.icon} style={{ fontSize: '1.5rem' }}></i>
    </span>
)}
content={item => (
    <div className="flex flex-column">
        <span>{item.status}</span>
    </div>
)}
/> */}
                                    <Timeline
                                        value={[
                                            { status: data?.driverStartPoint?.placeName, icon: 'pi pi-map-marker', },
                                            { status: data?.driverEndPoint?.placeName, icon: 'pi pi-flag', }
                                        ]}
                                        align="left"
                                        className="custom-timeline"
                                        marker={item => (
                                            <span className={`p-timeline-event-icon p-pt-2 text-white`}>
                                                <i className={item?.icon} style={{ fontSize: '1.5rem' }}></i>
                                            </span>
                                        )}
                                        content={item => (
                                            <div className="flex flex-column">
                                                <span>{item?.status}</span>
                                            </div>
                                        )}
                                    />

                                    <div className="flex flex-column justify-content-center ">

                                        <span className="text-xl mb-2">Passenger</span>


                                        <div className="flex text-lg">
                                            <div className="flex justify-content-center mr-1 text-white">
                                                <Rating value={value} onChange={(e) => setValue(e.value)} />
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <hr className="my-4" />

                                <div className="flex justify-content-between">
                                    <span className="text-md">{`Rs.${data.fare}`}</span>
                                    <span className="text-md">{data.status}</span>
                                </div>


                            </div>
                        </div>
                    </div>
                ))}

            </div>
        </>
    )
}

export default AllRides